
<template>
  <div class="content" style="padding-bottom: 20px; margin-bottom: 20px; min-height: 700px">
    <h1>任务执行情况</h1>
    <div class="title" style="padding-left: 20px"><span></span>任务包进展</div>
    <div class="progress">
      <el-steps :active="stepActive" finish-status="success" simple style="margin-top: 20px">
        <el-step :class="stepActiveShow == index + 1 ? 'active' : ''" @click.native="on_click(index + 1)"
          v-for="(item, index) in stateStepList" :key="index" :title="item"></el-step>
      </el-steps>
    </div>
    <div class="title" style="padding-left: 20px"><span></span>任务包信息</div>

    <el-form label-width="120px" label-position="right" class="demo-ruleForm">
      <el-form-item label="任务标题：">
        <div>{{ taskTitle }}</div>
      </el-form-item>
      <el-form-item label="执行日期：" v-if="timeType == '按年' || timeType == '按月' || disabled">
        <div>{{ startTime }} 至 {{ endTime }}</div>
      </el-form-item>
      <!-- 待受理字段 开始 -->
      <el-form-item label="执行部门：" v-if="stepActiveShow == 1">
        <div>{{ getOrg(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
      </el-form-item>
      <el-form-item label="发布公司：" v-if="stepActiveShow == 1">
        <div>{{ detail.tenantName }}</div>
      </el-form-item>
      <el-form-item label="发布人员：" v-if="stepActiveShow == 1">
        <div>{{ detail.senderStaffName }}</div>
      </el-form-item>
      <el-form-item label="发布时间：" v-if="stepActiveShow == 1">
        <div>{{ detail.confirmTime | getTimeDate }}</div>
      </el-form-item>
      <!-- 待受理字段 结束 -->

      <!-- 待派发字段 开始 -->

      <template v-if="detail.isChangeService=='Y'">
        <el-form-item label="是否转派：" v-if="stepActiveShow == 2">
          <div>是</div>
        </el-form-item>
        <el-form-item label="新执行公司：" v-if="stepActiveShow == 2">
          <div>{{ detail.newServiceTenantName }}</div>
        </el-form-item>
        <el-form-item label="新执行部门：" v-if="stepActiveShow == 2">
          <div>{{ getOrg(detail.organisationInfo) }}</div>
        </el-form-item>
      </template>
      <el-form-item label="执行部门：" v-if="stepActiveShow == 2">
        <div>{{ getOrg(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
      </el-form-item>
      <el-form-item label="受理公司：" v-if="stepActiveShow == 2">
        <div>{{ getCompanyFromDetail('待派发') }}</div>
      </el-form-item>
      <el-form-item label="受理人员：" v-if="stepActiveShow == 2">
        <div>{{ getPersonFromDetail('待派发') }}</div>
      </el-form-item>
      <el-form-item label="受理时间：" v-if="stepActiveShow == 2">
        <div>{{ detail.agreeTime | getTimeDate }}</div>
      </el-form-item>
      <!-- 待派发字段 结束 -->

      <!--已派发字段 开始 -->
      <template v-if="detail.isChangeService=='Y'">
        <el-form-item label="是否转派：" v-if="stepActiveShow == 3">
          <div>是</div>
        </el-form-item>
        <el-form-item label="新执行公司：" v-if="stepActiveShow == 3">
          <div>{{ detail.newServiceTenantName }}</div>
        </el-form-item>
        <el-form-item label="新执行部门：" v-if="stepActiveShow == 3">
          <div>{{ getOrg(detail.organisationInfo) }}</div>
        </el-form-item>
      </template>
      <el-form-item label="执行部门：" v-if="stepActiveShow == 3">
        <div>{{ getOrg(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
      </el-form-item>
      <el-form-item label="派发公司：" v-if="stepActiveShow == 3">
        <div>{{ getCompanyFromDetail('已派发') }}</div>
      </el-form-item>

      <el-form-item label="派发人员：" v-if="stepActiveShow == 3">
        <div>{{ getPersonFromDetail('已派发') }}</div>
      </el-form-item>

      <el-form-item label="派发时间：" v-if="stepActiveShow == 3">
        <div>{{ detail.sendTime | getTimeDate }}</div>
      </el-form-item>
      <!-- 已派发字段 结束 -->

      <!-- 已派发字段  任务执行 开始 -->
      <template v-if="detail.isChangeService=='Y'">
        <el-form-item label="是否转派：" v-if="stepActiveShow == 4">
          <div>是</div>
        </el-form-item>
        <el-form-item label="新执行公司：" v-if="stepActiveShow == 4">
          <div>{{ detail.newServiceTenantName }}</div>
        </el-form-item>
        <el-form-item label="新执行部门：" v-if="stepActiveShow == 4">
          <div>{{ getOrg(detail.organisationInfo) }}</div>
        </el-form-item>
      </template>
      <el-form-item label="执行公司：" v-if="stepActiveShow == 4">
        <div>{{ detail.tenantName }}</div>
      </el-form-item>
      <el-form-item label="执行部门：" v-if="stepActiveShow == 4">
        <div>{{ getOrg(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
      </el-form-item>
      <el-form-item label="执行状态：" v-if="stepActiveShow == 4">
        <div>{{ detail.timeState }}</div>
      </el-form-item>
      <!--已派发字段  任务执行 结束 -->

      <!--待考核字段 开始 -->
      <template v-if="detail.isChangeService=='Y'">
        <el-form-item label="是否转派：" v-if="stepActiveShow == 5">
          <div>是</div>
        </el-form-item>
        <el-form-item label="新执行公司：" v-if="stepActiveShow == 5">
          <div>{{ detail.newServiceTenantName }}</div>
        </el-form-item>
        <el-form-item label="新执行部门：" v-if="stepActiveShow == 5">
          <div>{{ getOrg(detail.organisationInfo) }}</div>
        </el-form-item>
      </template>
      <el-form-item label="执行部门：" v-if="stepActiveShow == 5">
        <div>{{ getOrg(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
      </el-form-item>
      <el-form-item label="上传公司：" v-if="stepActiveShow == 5">
        <div>{{ getCompanyFromDetail('待考核') }}</div>
      </el-form-item>

      <el-form-item label="上传人员：" v-if="stepActiveShow == 5">
        <div>{{ getPersonFromDetail('待考核') }}</div>
      </el-form-item>

      <el-form-item label="上传时间：" v-if="stepActiveShow == 5">
        <div>{{ getDateFromDetail('待考核') | getTimeDate }}</div>
      </el-form-item>

      <el-form-item label="报告文件：" v-if="stepActiveShow == 5">
        <div class="fileInfo" v-if="detail.tenantOperation">
          <img src="../../assets/images/word_icon.png" alt="" width="50" height="50" />
          <span class="fileName">{{ detail.tenantOperation && detail.tenantOperation[0].reportFileName }}</span>
          <a :href="
              detail.tenantOperation &&
              detail.tenantOperation[0].reportFile + '?response-content-type=application/octet-stream'
            " style="text-decoration: underline; cursor: pointer; color: #4fa1a4" download="FileName"
            class="downFile">点击下载</a>
          <a @click="
              toSee(
                detail.tenantOperation && detail.tenantOperation[0].reportFileName,
                detail.tenantOperation && detail.tenantOperation[0].reportFile,
              )
            " style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
            download="FileName" class="downFile">点击查看</a>
        </div>
      </el-form-item>

      <!--待考核字段 结束 -->

      <!--待结算字段 开始 -->
      <template v-if="detail.isChangeService=='Y'">
        <el-form-item label="是否转派：" v-if="stepActiveShow == 6">
          <div>是</div>
        </el-form-item>
        <el-form-item label="新执行公司：" v-if="stepActiveShow == 6">
          <div>{{ detail.newServiceTenantName }}</div>
        </el-form-item>
        <el-form-item label="新执行部门：" v-if="stepActiveShow == 6">
          <div>{{ getOrg(detail.organisationInfo) }}</div>
        </el-form-item>
      </template>
      <el-form-item label="执行部门：" v-if="stepActiveShow == 6">
        <div>{{ getOrg(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
      </el-form-item>
      <el-form-item label="考核公司：" v-if="stepActiveShow == 6">
        <div>{{ getCompanyFromDetail('待结算') }}</div>
      </el-form-item>

      <el-form-item label="考核人员：" v-if="stepActiveShow == 6">
        <div>{{ getPersonFromDetail('待结算') }}</div>
      </el-form-item>

      <el-form-item label="考核时间：" v-if="stepActiveShow == 6">
        <div>{{ getDateFromDetail('待结算') | getTimeDate }}</div>
      </el-form-item>
      <!--待结算字段 结束 -->

      <!--已完结字段 开始 -->
      <template v-if="detail.isChangeService=='Y'">
        <el-form-item label="是否转派：" v-if="stepActiveShow == 7">
          <div>是</div>
        </el-form-item>
        <el-form-item label="新执行公司：" v-if="stepActiveShow == 7">
          <div>{{ detail.newServiceTenantName }}</div>
        </el-form-item>
        <el-form-item label="新执行部门：" v-if="stepActiveShow == 7">
          <div>{{ getOrg(detail.organisationInfo) }}</div>
        </el-form-item>
      </template>
      <el-form-item label="执行部门：" v-if="stepActiveShow == 7">
        <div>{{ getOrg(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
      </el-form-item>
      <el-form-item label="结算企业：" v-if="stepActiveShow == 7">
        <div>{{ getCompanyFromDetail('已完结') }}</div>
      </el-form-item>

      <el-form-item label="结算人员：" v-if="stepActiveShow == 7">
        <div>{{ getPersonFromDetail('已完结') }}</div>
      </el-form-item>

      <el-form-item label="支付凭证：" v-if="stepActiveShow == 7" style="margin-bottom: 20px">
        <div class="fileInfo">
          <el-image v-for="(item, index) in payFile" :key="index"
            style="width: 100px; height: 100px; margin-right: 20px" :src="item" :preview-src-list="payFile">
          </el-image>
        </div>
      </el-form-item>

      <el-form-item label="发放凭证：" v-if="stepActiveShow == 7">
        <div class="fileInfo">
          <el-image v-for="(item, index) in giveFile" :key="index"
            style="width: 100px; height: 100px; margin-right: 20px" :src="item" :preview-src-list="giveFile">
          </el-image>
        </div>
      </el-form-item>

      <el-form-item label="上传时间：" v-if="stepActiveShow == 7">
        <div>{{ getDateFromDetail('已完结') | getTimeDate }}</div>
      </el-form-item>
      <!--已完结字段 结束 -->

      <el-form-item label="任务明细："> </el-form-item>
      <div class="back-color-fff p16" v-if="stepActiveShow == 1 || stepActiveShow == 2">
        <el-table :data="tableDataII" border stripe  header-cell-class-name="table_header" style="width: 100%">
          <el-table-column prop="parentTemplateDetailName" width="120" show-overflow-tooltip label="平台任务名称" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.parentTemplateDetailName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskType"  show-overflow-tooltip label="任务大类" width="150" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskType || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskContentName"  width="120" show-overflow-tooltip label="项目任务名称" header-align="center" align="left">
          </el-table-column>
          <el-table-column prop="menuName" show-overflow-tooltip  label="系统功能" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.surveyTitle|| scope.row.menuName || '-' }}</template>
          </el-table-column>
          <el-table-column label="业务员价格" width="160" header-align="center" align="left">
            <template slot-scope="scope">
              <span v-if="detail.taskPriceModel == 1 || (detail.state == '待受理' && detail.taskPriceModel == 2)">
                {{scope.row.taskPrice }} {{ scope.row.taskPriceUnit }}</span>
              <span v-if="detail.state != '待受理' && detail.taskPriceModel == 2 && scope.row.staffMinPrice != scope.row.staffMaxPrice">
                {{ scope.row.staffMinPrice }} ～ {{ scope.row.staffMaxPrice }}{{ scope.row.taskPriceUnit }}</span>
              <span v-if="detail.state != '待受理' && detail.taskPriceModel == 2 && scope.row.staffMinPrice == scope.row.staffMaxPrice"> 
                {{ scope.row.staffMinPrice }}{{ scope.row.taskPriceUnit }}</span>
            </template>
          </el-table-column>
 
          <el-table-column show-overflow-tooltip label="任务量" header-align="center" align="left">
            <template slot-scope="scope">
              <div v-if="scope.row.taskTotalType!='固定量人均'&&scope.row.taskTotalType!='不限量'"
                style="display: flex; align-items: center;">
                <div>{{ scope.row.taskTotal }}</div>
                <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
              </div>
              <div v-if="scope.row.taskTotalType=='不限量'" style="display: flex; align-items: center;">
                <div>不限量</div>
              </div>
              <div v-if="scope.row.taskTotalType=='固定量人均'" style="display: flex; align-items: center;">
                <div>{{scope.row.taskTotal }}</div>
                <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- v26.3.3 FOUR-2997：标注行三列只读展示（形态对齐受理页；仅含 SJBZ 行的包渲染，普通行显示 '-'） -->
          <template v-if="hasSjbzRows()">
            <el-table-column label="标注数据" header-align="center" align="center" width="180" show-overflow-tooltip>
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">{{ sjbzDatasetText(scope.row) }}</template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="标注人员要求" header-align="center" align="center" width="110">
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">
                  <a v-if="sjbzReqSet(scope.row)" class="txt-color" @click="openSjbzReqView(scope.row)">查看</a>
                  <span v-else>-</span>
                </template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="质检比例" header-align="center" align="center" width="100">
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">{{ sjbzConf(scope.row).qcRatio != null ? sjbzConf(scope.row).qcRatio + '%' : '-' }}</template>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="taskType show-overflow-tooltip" label="限定品种" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.goodsInfo && scope.row.goodsInfo.length" class="txt-color"
                  @click="handleChooseGoods(scope.$index)">共{{
                  scope.row.goodsInfo.length
                  }}个品</span>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tenantTaskNote" show-overflow-tooltip width="250" label="任务介绍" header-align="center" align="left">
            <template slot-scope="scope">{{ getTenantTaskNote(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="taskContentName" show-overflow-tooltip label="服务区域" header-align="center" align="left">
            <template slot-scope="scope">{{ getArea(scope.row) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="back-color-fff p16" v-else>
        <el-table :data="tableDataII" style="width: 100%" border stripe border header-cell-class-name="table_header">
          <el-table-column show-overflow-tooltip prop="parentTemplateDetailName" label="平台任务名称" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.parentTemplateDetailName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="taskType" label="任务大类" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskType || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="taskContentName" label="项目任务名称" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="menuName" label="系统功能" header-align="center" align="left">
            <template slot-scope="scope">{{scope.row.surveyTitle|| scope.row.menuName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="taskTotal" label="计划量" header-align="center" align="left">
            <!-- <template slot-scope="scope">
              <div>{{ scope.row.taskTotal }}{{ scope.row.taskTotalUnit }}</div>
            </template> -->
            <template slot-scope="scope">
              <div v-if="scope.row.taskTotalType!='固定量人均'&&scope.row.taskTotalType!='不限量'"
                style="display: flex; align-items: center;">
                <div>{{ scope.row.taskTotal }}</div>
                <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
              </div>
              <div v-if="scope.row.taskTotalType=='不限量'" style="display: flex; align-items: center; ">
                <div>不限量</div>
              </div>
              <div v-if="scope.row.taskTotalType=='固定量人均'" style="display: flex; align-items: center;">
                <div>{{scope.row.taskTotal }}</div>
                <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
              </div>
            </template>
          </el-table-column>

          <!-- v26.3.3 FOUR-2997：标注行三列只读展示（进展态表格同款，实际完成量之前） -->
          <template v-if="hasSjbzRows()">
            <el-table-column label="标注数据" header-align="center" align="center" width="180" show-overflow-tooltip>
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">{{ sjbzDatasetText(scope.row) }}</template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="标注人员要求" header-align="center" align="center" width="110">
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">
                  <a v-if="sjbzReqSet(scope.row)" class="txt-color" @click="openSjbzReqView(scope.row)">查看</a>
                  <span v-else>-</span>
                </template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="质检比例" header-align="center" align="center" width="100">
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">{{ sjbzConf(scope.row).qcRatio != null ? sjbzConf(scope.row).qcRatio + '%' : '-' }}</template>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </template>

          <el-table-column prop="realCount" label="实际完成量" header-align="center" align="left">
            <template slot-scope="scope">
              <div>{{ scope.row.realCount.toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/,'$1') }}{{ scope.row.taskTotalUnit
                }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="finishRate" label="完成率" header-align="center" align="right">
            <template slot-scope="scope">
              <div>{{scope.row.taskTotalType=='不限量'&&scope.row.realCount?'100.00%':scope.row.finishRate.toFixed(2)+'%'
                }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <a class="txt-color" @click="rowDetail=scope.row;showRowDetail=true;">执行情况</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-button size="medium" type="info"
        style="width: 200px; margin-top: 40px;margin-bottom: 20px;background: #F0F0F0; color: #323233;border: 1px solid #DCDEE0 ;"
        @click="$router.go(-1)">返回</el-button>
    </el-form>

    <!-- <el-dialog title="品种任务量" :visible.sync="visible2" width="40%" center>
      <el-table  border stripe border header-cell-class-name="table_header" :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="产品名称" show-overflow-tooltip header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="任务量" header-align="center" align="left">
          <template slot-scope="scope">
            <div>{{ scope.row.goodsCount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsSpec" label="产品规格" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.goodsSpec }}</template>
        </el-table-column>
      </el-table>
    </el-dialog> -->

    <el-dialog title="部门执行情况" v-if="visible4" :visible.sync="visible4" width="70%" center>
      <div class="title"><span></span>基本信息</div>
      <div class="content-item">
        <span>任务名称：<i>{{ taskDetail.taskContentName }}</i></span>
        <span style="margin-left: 60px">系统功能：<i>{{ taskDetail.taskType }}</i></span>
      </div>

      <div class="title">
        <div>
          <span></span>
          各部门执行情况
        </div>
        <el-input v-model="serachOrgTxt" clearable class="search-box" placeholder="请输入组织"></el-input>

      </div>
      <el-table border stripe border header-cell-class-name="table_header" :data="tableOrg" style="width: 100%">
        <el-table-column v-for="(item, index) in tabHead" :label="item.label" :property="item.property" :key="index"
          show-overflow-tooltip header-align="center" :align="item.titleAlign" :render-header="renderHeader">
          <template slot-scope="scope">
            <div>{{ item.property == 'finishRate' ? scope.row[item.property] + '%' : (scope.row[item.property] || '-')
              }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="seePeople(scope.row)">人员执行明细</a>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="人员执行情况" v-if="visible5" :visible.sync="visible5" width="70%" center>
      <div class="title"><span></span>基本信息</div>
      <div class="content-item">
        <span>任务名称：<i>{{ taskDetail.taskContentName }}</i></span>
        <span style="margin-left: 60px">系统功能：<i>{{ taskDetail.taskType }}</i></span>
      </div>
      <div class="title">
        <span></span>
        各人员执行情况
        <el-input v-model="serachPeopleTxt" clearable class="search-box" placeholder="请输入名称"></el-input>
      </div>

      <el-table border stripe border header-cell-class-name="table_header" :data="tableStaff" style="width: 100%">
        <el-table-column v-for="(item, index) in tabHeadII" :label="item.label" :property="item.property" :key="index"
          header-align="center" :align="item.titleAlign" :render-header="renderHeader">
          <template slot-scope="scope">
            <div>{{ scope.column.property == 'finishRate' ? (scope.row[scope.column.property]+'%') :
              scope.row[scope.column.property] == null ? '-' : scope.row[scope.column.property] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 限制品种弹窗 开始 -->
    <GoodsLimitSelect :disabled="true" :sendTenantGuid="detail.tenantGuid" :taskList="tableDataII"
      :taskIndex="currentIndex" :showFromLevel="visible2" @closeGoodsLimit="visible2 = false"></GoodsLimitSelect>
    <!-- 限制品种弹窗 结束 -->

    <PersonTaskSum planTitle="计划量" :detail="rowDetail" v-if="showRowDetail" @close="showRowDetail = false;">
    </PersonTaskSum>

    <!-- 标注行"标注人员要求"纯详情弹框（FOUR-2997：共用组件 LabelReqView，与受理页同源） -->
    <el-dialog :title="sjbzReqViewTitle()" :visible.sync="showSjbzReqView" width="800px" top="10vh" append-to-body>
      <label-req-view v-if="showSjbzReqView" :conf="sjbzReqViewConf()"></label-req-view>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="showSjbzReqView = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment';
  import PersonTaskSum from './components/PersonTaskSum.vue';
  import GoodsLimitSelect from '@/components/GoodsLimitSelect';
  import LabelReqView from './components/LabelReqView.vue';
  export default {
    components: {
      PersonTaskSum,
      GoodsLimitSelect,
      LabelReqView,
      'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    },
    data() {
      return {
        currentIndex:null,
        showRowDetail:false,
        rowDetail:{},

        timeType: '',
        timeRange: '',
        year: '',
        month: '',
        startTime: '',
        endTime: '',
        taskTitle: '',
        tenantName: '',
        tenantList: [],
        taskContentList: [],
        tableDataII: [],
        sjbzReqViewRow: null, //标注人员要求纯详情弹框当前行（FOUR-2997）
        showSjbzReqView: false,
        visible2: false,
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          taskContentName: '',
          tenantName: '',
        },
        tableData: [],
        multipleSelection: [],
        fullscreenLoading: false,
        disabled: false,
        detail: {},

        goodsIndex: 0,

        visible4: false,
        taskDetail: {},
        tableOrg: [],
        tabHead: [],

        visible5: false,
        tableStaff: [],
        tabHeadII: [],
        taskStaffDetail: {},
        stateStepList: ['药企发布', '任务包受理', '任务派发', '任务执行'],//, '成果汇报', '任务考核', '结算并付款'
        stepActive: null,
        stepActiveShow: null,
        payFile: [],
        giveFile: [],
        serachOrgTxt: '',
        tableOriginOrg: [],
        serachPeopleTxt: '',
        tableOriginStaff: [],
      };
    },

    created() {
      this.getDetail();
    },
    watch: {
      serachOrgTxt(val) {
        var tableOriginOrg = this.tableOriginOrg;
        console.log(tableOriginOrg)
        if (!val) {
          this.tableOrg = tableOriginOrg;
        } else {
          var str = tableOriginOrg
          var key = val;
          var arr = []
          for (let index = 0; index < tableOriginOrg.length; index++) {
            if (str[index].organisationName.indexOf(key) >= 0) {
              arr.push(str[index]);//返回满足条件的数据
            }
          }
          this.tableOrg = arr;
        }

      },
      serachPeopleTxt(val) {
        var tableOriginStaff = this.tableOriginStaff;
        console.log(tableOriginStaff)
        if (!val) {
          this.tableStaff = tableOriginStaff;
        } else {
          var str = tableOriginStaff
          var key = val;
          var arr = []
          for (let index = 0; index < tableOriginStaff.length; index++) {
            if (str[index].staffName.indexOf(key) >= 0) {
              arr.push(str[index]);//返回满足条件的数据
            }
          }
          this.tableStaff = arr;
        }

      },
      visible5(val) {
        if (!val) {
          var self = this;
          var req = {
            guid: this.$route.query.guid,
          };
          self.fullscreenLoading = true;
          self.api.get(`/${serverConfig.msSalesPerformService}/task/data/get-detail`, req).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              var detail = res.data.data;
              this.taskTitle = detail.taskTitle;
              this.tenantName = detail.tenantName;
              this.timeType = detail.timeType;
              setTimeout(() => {
                this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
                this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
              }, 100);
              this.departmentData = [
                {
                  organisationName: detail.senderStaffName,
                  guid: detail.senderStaffGuid,
                },
              ];
              this.departmentList = [
                {
                  organisationName: detail.senderStaffName,
                  guid: detail.senderStaffGuid,
                },
              ];

              this.tableDataII = detail.taskDetailList;
              var tableDataII = this.tableDataII;
              tableDataII.forEach((item) => {
                if (item.goodsInfo) {
                  item.goodsInfo = JSON.parse(item.goodsInfo);
                }
                if (item.taskPrice && item.taskTotal) {
                  item.taskTarget = item.taskPrice * item.taskTotal;
                  item.taskTarget = item.taskTarget.toFixed(2);
                } else {
                  item.taskTarget = 0;
                }
              });
              this.tableDataII = tableDataII;

              this.detail = detail;
              if (this.detail.tenantPay) {
                let payFile = JSON.parse(this.detail.tenantPay[0].payFile);
                payFile.forEach((item) => {
                  this.payFile.push(item.path || item.url);
                });
                let giveFile = JSON.parse(this.detail.tenantPay[0].giveFile);
                giveFile.forEach((item) => {
                  this.giveFile.push(item.path || item.url);
                });
              }
              this.multipleSelection = detail.taskDetailList;
              this.$forceUpdate();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        }
      }
    },
    methods: {
      // ===== SJBZ 标注行三列（FOUR-2997：与受理页 taskDeliverModify 同源实现） =====
      isSjbzRow(row) {
        return row && row.taskContentType === 'SJBZ';
      },
      hasSjbzRows() {
        return (this.tableDataII || []).some((row) => this.isSjbzRow(row));
      },
      // 标注行 labelConfig 解析（解析失败降级空对象；$set 使缓存响应式）
      sjbzConf(row) {
        if (!row) return {};
        if (!row.__sjbzConf) {
          try {
            this.$set(row, '__sjbzConf', row.labelConfig ? (JSON.parse(row.labelConfig) || {}) : {});
          } catch (e) {
            this.$set(row, '__sjbzConf', {});
          }
        }
        return row.__sjbzConf;
      },
      // 标注人员要求是否已设置（有任一配置项才给"查看"入口）
      sjbzReqSet(row) {
        const conf = this.sjbzConf(row);
        return !!(conf.labelSnapshot || (conf.labelSnapshots && conf.labelSnapshots.length) || conf.modelGuid
          || conf.deptGuid || conf.identity
          || (conf.titleGuids && conf.titleGuids.length) || conf.majorGuid || conf.experience);
      },
      // 标注数据列文本：数据集名（数据量+单位）
      sjbzDatasetText(row) {
        const conf = this.sjbzConf(row);
        if (!conf.datasetName) return '-';
        return conf.dataAmount != null && conf.dataAmount !== ''
          ? `${conf.datasetName}（${conf.dataAmount}${conf.dataUnit || ''}）`
          : conf.datasetName;
      },
      openSjbzReqView(row) {
        this.sjbzReqViewRow = row;
        this.showSjbzReqView = true;
      },
      sjbzReqViewTitle() {
        const name = this.sjbzReqViewRow ? this.sjbzReqViewRow.taskContentName : '';
        return name ? `【${name}】标注人员要求` : '标注人员要求';
      },
      sjbzReqViewConf() {
        return this.sjbzReqViewRow ? this.sjbzConf(this.sjbzReqViewRow) : {};
      },
      getOrg(list) {
        if (typeof list == 'string') {
          list = JSON.parse(list);
        }
        let personArr = [];
        let personTip = '';
        let departmentArr = [];
        let departmentTip = '';
        let personNum = 0;
        let departmentNum = 0;
        if (list && list.length > 0) {
          list.forEach(i => {
            if (i.objectType == '人员') {
              personArr.push(i.organisationName || i.name);
              personNum = personNum + 1;
            } else {
              departmentNum = departmentNum + 1;
              departmentArr.push(i.organisationName || i.name);
            }
          });
        }
        personTip =
          personArr.length > 2
            ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
            : personArr.splice(0, 2).join('、');
        console.log(personArr);
        departmentTip =
          departmentArr.length > 2
            ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
            : departmentArr.splice(0, 2).join('、');
        return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
      },
      renderHeaderII: function (h, { column, $index }) {
        if (column.label == '完成率') return [column.label];
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  //当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                ['每个品种的任务量 = 任务量除以品种个数'],
              ),
              h('span', {
                //问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },
      getTenantTaskNote(detail) {
        if (detail.taskTotalType == '固定量人均') {
          var total = detail.taskTotal;
          return detail.tenantTaskNote.replace('#总任务量#', total);
        } else if (detail.taskTotalType == '系统计算') {
          var total = detail.taskTotal;
          return detail.tenantTaskNote.replace('#总任务量#', total);
        }
      },
      //点击填写数量
      addAmount(goodsIndex, list, taskTotal) {
        this.visible2 = true;
        this.goodsIndex = goodsIndex;
        this.tableData = list;
      },
      getArea(detail) {
        var clientArea = JSON.parse(detail.clientArea);
        var list = [];
        clientArea.forEach((item) => {
          list.push(item.name);
        });
        return list.join('、');
      },
      on_click(index) {
        if (this.stepActive < index) return;
        this.stepActiveShow = index;
      },
      getCompanyFromDetail(state) {
        var taskOperateHist = this.detail.taskOperateHist;
        if (!taskOperateHist) return '-';
        var company = '-';
        taskOperateHist.forEach((item) => {
          if (item.currentState == state) {
            company = item.operateTenantName;
          }
        });
        return company;
      },
      getPersonFromDetail(state) {
        var taskOperateHist = this.detail.taskOperateHist;
        if (!taskOperateHist) return '-';
        var username = '-';
        taskOperateHist.forEach((item) => {
          if (item.currentState == state) {
            username = item.createUserName;
          }
        });
        return username;
      },
      getDateFromDetail(state) {
        var taskOperateHist = this.detail.taskOperateHist;
        if (!taskOperateHist) return '-';
        var createTime = '-';
        taskOperateHist.forEach((item) => {
          if (item.currentState == state) {
            createTime = item.createTime;
          }
        });
        return createTime;
      },
      //初始化状态
      initProgress(detail) {
        var state = detail.state;
        var stepActive = this.stepActive;
        var stepActiveShow = this.stepActive;
        if (state == '待受理') {
          this.stepActive = 1;
          this.stepActiveShow = 1;
        }
        if (state == '待派发') {
          this.stepActive = 2;
          this.stepActiveShow = 2;
        }
        if (state == '已派发' || state == '待上传') {
          this.stepActive = 4;
          this.stepActiveShow = 4;
        }
        if (state == '待考核') {
          this.stepActive = 5;
          this.stepActiveShow = 5;
        }
        if (state == '待结算') {
          this.stepActive = 6;
          this.stepActiveShow = 6;
        }
        if (state == '已完结') {
          this.stepActive = 7;
          this.stepActiveShow = 7;
        }

      },
      getNote(detail) {
        var taskNote = detail.taskNote;
        var taskTotal = detail.taskTotal;
        var taskTag = JSON.parse(detail.taskTag).join('、');
        var taskTotalUnit = detail.taskTotalUnit;
        return `${taskNote}，不少于${taskTotal}${taskTotalUnit}（任务要求：${taskTag}）；`;
      },
      getDetail() {
        var self = this;
        if (!this.$route.query.guid) return;
        if (this.$route.query.is_edit) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }

        var req = {
          guid: this.$route.query.guid,
        };
        self.fullscreenLoading = true;
        self.api.get(`/${serverConfig.msSalesPerformService}/task/data/get-detail`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            var detail = res.data.data;
            self.initProgress(detail);
            this.taskTitle = detail.taskTitle;
            this.tenantName = detail.tenantName;
            this.timeType = detail.timeType;
            setTimeout(() => {
              this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
              this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
            }, 100);
            this.departmentData = [
              {
                organisationName: detail.senderStaffName,
                guid: detail.senderStaffGuid,
              },
            ];
            this.departmentList = [
              {
                organisationName: detail.senderStaffName,
                guid: detail.senderStaffGuid,
              },
            ];

            this.tableDataII = detail.taskDetailList;
            var tableDataII = this.tableDataII;
            tableDataII.forEach((item) => {
              if (item.goodsInfo) {
                item.goodsInfo = JSON.parse(item.goodsInfo);
              }
              if (item.taskPrice && item.taskTotal) {
                item.taskTarget = item.taskPrice * item.taskTotal;
                item.taskTarget = item.taskTarget.toFixed(2);
              } else {
                item.taskTarget = 0;
              }
            });
            this.tableDataII = tableDataII;

            this.detail = detail;
            if (this.detail.tenantPay) {
              let payFile = JSON.parse(this.detail.tenantPay[0].payFile);
              payFile.forEach((item) => {
                this.payFile.push(item.path || item.url);
              });
              let giveFile = JSON.parse(this.detail.tenantPay[0].giveFile);
              giveFile.forEach((item) => {
                this.giveFile.push(item.path || item.url);
              });
            }
            this.multipleSelection = detail.taskDetailList;
            this.$forceUpdate();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },

      //确认发布

      // seeOrg(detail) {
      //   console.log(detail);
      //   this.visible4 = true;
      //   this.serachOrgTxt = '';
      //   this.taskDetail = detail;
      //   this.tableOrg = detail.taskDetailOrganisationList;
      //   this.tableOrg.forEach((item) => {
      //     item.realCount = Number(item.realCount).toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
      //     if (item.planCount == 0) {
      //       item.planCount = '不限量'
      //       if (item.realCount && item.realCount !== '0' && item.realCount !== 0) {
      //         item.finishRate = 100.00;
      //       } else {
      //         item.finishRate = 0.00;
      //       }
      //     }
      //     item.taskDetailStaffList = [];
      //   });

      //   this.tableOrg.forEach((i, index) => {
      //     detail.taskDetailStaffList.forEach((j) => {
      //       if (i.organisationName == j.organisationName) {
      //         i.taskDetailStaffList.push(j);
      //       }
      //     });
      //   });

      //   var tabHead = [
      //     {
      //       property: 'organisationName',
      //       label: '部门名称',
      //       titleAlign:'left'
      //     },
      //     {
      //       property: 'planCount',
      //       label: '计划量',
      //       titleAlign:'right'
      //     },
      //     {
      //       property: 'realCount',
      //       label: '实际完成量',
      //       titleAlign:'right'
      //     },
      //     {
      //       property: 'finishRate',
      //       label: '实际完成率',
      //       titleAlign:'right'
      //     },
      //   ];

      //   this.tableOrg.forEach((item, index) => {
      //     if (item.goodsInfo) {
      //       item.goods = JSON.parse(item.goodsInfo);
      //     }
      //     item.finishRate = Number(item.finishRate).toFixed(2) + ''.indexOf('%') > -1 ? Number(item.finishRate).toFixed(2) + '%' : Number(item.finishRate).toFixed(2);
      //   });

      //   this.tableOrg.forEach((p) => {
      //     if (p.goods) {
      //       p.goods.forEach((q) => {
      //         // q.name = q.name + `(${q.goodsUnit})`;
      //         q.name = q.name;
      //         if (q.goodsCount) {
      //           p[q.name] =
      //             +((q.goodsRealCount / q.goodsCount) * 100).toFixed(2) +
      //             '%' +
      //             '（' +
      //             q.goodsRealCount +
      //             '/' +
      //             q.goodsCount +
      //             '）';
      //         } else {
      //           p[q.name] = '0.00%（' + q.goodsRealCount + '/' + q.goodsCount + '）';
      //         }
      //       });
      //     }
      //   });
      //   var re = /[^\u4e00-\u9fa5]/;
      //   for (const k in this.tableOrg[0]) {
      //     var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
      //     if (reg.test(k)) {
      //       tabHead.push({
      //         property: k,
      //         label: k,
      //       });
      //     }
      //   }
      //   this.tabHead = tabHead;
      //   this.tableOriginOrg = this.tableOrg;

      //   console.log(this.tableOrg);
      //   console.log(this.tabHead);
      // },
      // seePeople(detail) {
      //   this.taskStaffDetail = detail;
      //   console.log(this.taskStaffDetail);
      //   this.visible5 = true;
      //   this.serachPeopleTxt = '';
      //   var taskDetailNoStaffList = [];
      //   detail.taskDetailStaffList.forEach(item => {
      //     item.realCount = item.realCount.toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
      //     if (item.planCount || detail.planCount == '不限量') { //隐藏计划为0的
      //       taskDetailNoStaffList.push(item)
      //     }
      //   })
      //   this.tableStaff = taskDetailNoStaffList;
      //   var tabHead = [
      //     {
      //       property: 'staffName',
      //       label: '人员名称',
      //       titleAlign:'left'
      //     },
      //     {
      //       property: 'planCount',
      //       label: '计划量',
      //       titleAlign:'right'
      //     },
      //     {
      //       property: 'realCount',
      //       label: '实际完成量',
      //       titleAlign:'right'
      //     },
      //     {
      //       property: 'finishRate',
      //       label: '实际完成率',
      //       titleAlign:'right'
      //     },
      //   ];
      //   this.tableStaff.forEach((item, index) => {

      //     if (item.goodsInfo) {
      //       item.goods = JSON.parse(item.goodsInfo);
      //     }
      //     if (this.taskStaffDetail.planCount == '不限量') {
      //       item.planCount = '不限量'
      //       if (item.realCount) {
      //         item.finishRate = '100.00%';
      //       } else {
      //         item.finishRate = '0.00%';
      //       }
      //     }
      //     item.finishRate = Number(item.finishRate).toFixed(2) + ''.indexOf('%') > -1 ? Number(item.finishRate).toFixed(2) + '%' : Number(item.finishRate).toFixed(2);
      //   });

      //   this.tableStaff.forEach((p, index) => {
      //     if (p.goods) {
      //       p.goods.forEach((q) => {
      //         q.name = q.name;
      //         if (q.goodsCount) {
      //           p[q.name] =
      //             +((q.goodsRealCount / q.goodsCount) * 100).toFixed(2) +
      //             '%' +
      //             '（' +
      //             q.goodsRealCount +
      //             '/' +
      //             q.goodsCount +
      //             '）';
      //         } else {
      //           p[q.name] = '0%（' + q.goodsRealCount + '/' + q.goodsCount + '）';
      //         }
      //       });
      //     }
      //   });

      //   for (const k in this.tableStaff[0]) {
      //     var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
      //     if (reg.test(k)) {
      //       tabHead.push({
      //         property: k,
      //         label: k,
      //       });
      //     }
      //   }

      //   this.tabHeadII = tabHead;
      //   this.tableOriginStaff = this.tableStaff;

      // },
      renderHeader: function (h, { column, $index }) {
        if ($index == 0 || $index == 1 || $index == 2 || $index == 3 || $index == 5) {
          return [column.label];
        }
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  //当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                ['品种实际完成量/品种任务计划量'],
              ),
              h('span', {
                //问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },
      toSee(contractFileName, url) {
        if (contractFileName.indexOf('pdf') > -1) {
          window.open(url);
        } else {
          window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url));
        }
      },
      handleChooseGoods(index){
        this.currentIndex = index;
        this.visible2 =true;
      },
    },
  };
</script> 
<style scoped>
.content {
  background: #fff;
  font-size: 18px;
}
/deep/.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/deep/.el-form-item__content {
  margin-left: 0px !important;
}
.p16 {
  padding-top: 0;
  padding-left: 30px;
  padding-right: 30px;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management-list {
  display: flex;
  align-items: center;
  margin-left: 64px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #606266;
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name {
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}
.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}
.input-item .input-title {
  margin-right: 14px;
}
input:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
.date {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 10px 30px;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position:relative;
}
.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}

.content-item {
  margin-bottom: 20px;
  padding-left: 20px;
}
.content-item i {
  font-style: normal;
  font-weight: bold;
}
/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}

/deep/ .el-table td {
  padding: 10px 0px;
}
/deep/.el-step.is-simple:not(:last-of-type) .el-step__title {
  word-break: keep-all;
}
/deep/ .el-steps--simple {
  padding: 0px 20px;
}
/deep/ .el-step {
  padding: 13px 0;
}
/deep/ .el-step__head.is-success {
  color: #4fa1a4;
  border-color: #4fa1a4;
}
/deep/ .el-step__title.is-success {
  color: #4fa1a4;
}
/deep/ .active .el-step__head.is-success {
  color: #000;
  border-color: #000;
}

/deep/ .active .el-step__title.is-success {
  font-weight: bold;
  color: #000;
}

/deep/ .active.el-step.is-simple .el-step__arrow::after {
  background: #000;
}
/deep/ .active.el-step.is-simple .el-step__arrow::before {
  background: #000;
}
/deep/ .is-process {
  color: #c0c4cc;
}
/deep/ .el-step__head.is-process {
  border-color: #c0c4cc;
}
.progress {
  padding: 0 20px;
  padding-bottom: 20px;
  cursor: pointer;
}
.fileInfo {
  display: flex;
  align-items: center;
}
.fileInfo .fileName {
  margin: 0 20px;
}
.search-box{
  position:absolute;
  width:260px;
  right:0;
  bottom:0;
}
</style>
